import * as React from 'react';
import CollapsingFacet from './collapsing_facet';
import SelectFacetOption from './select_facet_option';
import { Filter, WidgetType } from './search_filters';

interface IProps {
  filter: Filter;
}

// Corresponds to `.facet__option:nth-child(n+7)` in facets.scss
const COLLAPSE_THRESHOLD = 7;

const SelectFacet = ({ filter }: IProps) => (
  <CollapsingFacet
    count={filter.options.length}
    countThreshold={COLLAPSE_THRESHOLD}
    classPrefix="facet"
  >
    <div className="facet__heading">{filter.name}</div>
    <ul className="facet__options">
      {filter.options.map((option, idx) => (
        <SelectFacetOption
          key={idx}
          option={option}
          checkbox={filter.widgetType === WidgetType.CHECKBOX}
        />
      ))}
    </ul>
  </CollapsingFacet>
);

export default SelectFacet;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/select_facet.tsx